import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = ["disabled", "placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "mandatory"
}
const _hoisted_25 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = ["disabled", "placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "has_checkbox"
}
const _hoisted_33 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = ["disabled", "placeholder"]
const _hoisted_36 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_37 = {
  key: 2,
  class: "col-12"
}
const _hoisted_38 = {
  key: 3,
  class: "col-md-12"
}
const _hoisted_39 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_40 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#discard_modal"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "position-relative" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "d-flex align-items-center gap-3" }
const _hoisted_45 = { class: "row justify-content-center" }
const _hoisted_46 = { class: "col" }
const _hoisted_47 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "version_error_message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" REVISION NUMBER "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('form.revision_number.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.version.revision_number) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.revision_number }]]),
                  required: "",
                  disabled: _ctx.published,
                  type: "text",
                  pattern: "^(0|(?:[1-9]\\d*))\\.(0|(?:[1-9]\\d*))\\.?(0|(?:[1-9]\\d*))?",
                  placeholder: _ctx.$t('form.revision_number.placeholder')
                }, null, 10 /* CLASS, PROPS */, _hoisted_7), [
                  [_vModelText, _ctx.version.revision_number]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.revision_number ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.revision_number, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_9,
            _createCommentVNode(" TITLE "),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('form.title.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.version.title) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.title }]]),
                  required: "",
                  disabled: _ctx.published
                }, null, 10 /* CLASS, PROPS */, _hoisted_13), [
                  [_vModelText, _ctx.version.title]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.title ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.title, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_15,
            _createCommentVNode(" BODY "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('form.body.label')), 1 /* TEXT */),
                _createElementVNode("div", {
                  class: "mb-0 quill-editor",
                  disabled: _ctx.published
                }, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    toolbar: _ctx.toolbar,
                    content: _ctx.version.body,
                    "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.version.body) = $event)),
                    contentType: "html",
                    ref: "editor",
                    disabled: _ctx.published,
                    readOnly: _ctx.published
                  }, null, 8 /* PROPS */, ["toolbar", "content", "disabled", "readOnly"])
                ], 8 /* PROPS */, _hoisted_19),
                _createCommentVNode("  <textarea v-model=\"version.body\" class=\"form-control shadow-none text-black\"\n                                :class=\"[{ 'is-invalid': submitted && errors?.body }]\" rows=\"6\"></textarea> "),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.body ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.body, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" MANDATORY "),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none me-8",
                  type: "checkbox",
                  role: "switch",
                  disabled: _ctx.published,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.version.mandatory) = $event)),
                  id: "mandatory",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchReset('mandatory_message')))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_23), [
                  [_vModelCheckbox, _ctx.version.mandatory]
                ]),
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.mandatory.label')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" MANDATORY "),
            (_ctx.version.mandatory)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createCommentVNode(" <label class=\"d-block text-black fw-semibold mb-10\">\n                                {{ $t('form.title.label') }}\n                            </label> "),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.version.mandatory_message) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.mandatory_message }]]),
                      disabled: _ctx.published,
                      placeholder: _ctx.$t('form.mandatory.placeholder'),
                      rows: "6"
                    }, null, 10 /* CLASS, PROPS */, _hoisted_27), [
                      [_vModelText, _ctx.version.mandatory_message]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.mandatory_message ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.mandatory_message, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" HAS CHECKBOX "),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input shadow-none me-8",
                  type: "checkbox",
                  role: "switch",
                  disabled: _ctx.published,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.version.has_checkbox) = $event)),
                  id: "has_checkbox",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchReset('checkbox_disclaimer')))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_31), [
                  [_vModelCheckbox, _ctx.version.has_checkbox]
                ]),
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('form.has_checkbox.label')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" HAS CHECKBOX "),
            (_ctx.version.has_checkbox)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createCommentVNode(" <label class=\"d-block text-black fw-semibold mb-10\">\n                                {{ $t('form.title.label') }}\n                            </label> "),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.version.checkbox_disclaimer) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.checkbox_disclaimer }]]),
                      disabled: _ctx.published,
                      placeholder: _ctx.$t('form.has_checkbox.placeholder'),
                      required: "",
                      rows: "6"
                    }, null, 10 /* CLASS, PROPS */, _hoisted_35), [
                      [_vModelText, _ctx.version.checkbox_disclaimer]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.checkbox_disclaimer ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.checkbox_disclaimer, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createCommentVNode(" DISCARD "),
                    (_ctx.update && !_ctx.published)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('feature.contents.$blocks.discard_changes')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_43)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.update && !_ctx.published)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "default-btn transition outlined fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                            type: "submit",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.submitted = true; _ctx.version.published = true})
                          }, _toDisplayString(_ctx.$t('cta.publish_consent')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.published)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                            type: "submit",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitted = true))
                          }, _toDisplayString(_ctx.$t('cta.save_consent_version')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.published)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.createVersion && _ctx.createVersion(...args))),
                            type: "button"
                          }, _toDisplayString(_ctx.$t('cta.create_consent_version')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      id: "discard_modal",
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.discard())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}